import { RequireConfig } from '@common/config';
import { AppErrorBoundary } from '@common/error';
import { AccesRefuse } from '@common/error/src/pages/AccesRefuse';
import { useScrollTopOnRouteChange } from '@common/hooks';
import { Deconnexion, RequireSession } from '@common/oauth2';
import { ConditionUtilisation, MentionsLegales, PolitiqueConfidentialite, PolitiqueCookies } from '@common/ui/legal';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { RequireOFARole } from './guards/RequireOFARole';
import { BaseLayout } from './layouts/base/Base.layout';
import { StepperLayout } from './layouts/stepper/Stepper.layout';
import { Archives } from "./pages/Archives/Archives";
import { Campagne } from './pages/Campagne/Campagne';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { MyOfa } from './pages/MyOfa/MyOfa';
import { EditOfaEtablissement } from './pages/MyOfa/pages/edit-ofa-etablissement/EditOfaEtablissement';
import { EditOfaEtablissementsList } from './pages/MyOfa/pages/edit-ofa-etablissement/EditOfaEtablissementsList';
import { EditOfaInfoStep1 } from './pages/MyOfa/pages/edit-ofa-info/EditOfaInfoStep1';
import { EditOfaInfoStep2 } from './pages/MyOfa/pages/edit-ofa-info/EditOfaInfoStep2';
import { StepperPage } from './pages/MyOfa/pages/edit-ofa-info/StepperPage';
import { EditEtablissementRncps } from './pages/MyOfa/pages/edit-ofa-rncp/EditEtablissementRncps';
import { RncpEtablissementsList } from './pages/MyOfa/pages/etablissements-list-rncp/RncpEtablissementsList';
import './App.css';
import {MatomoProvider} from "./analytics/MatomoProvider";

export function App() {
  useScrollTopOnRouteChange();

  return (
    <AppErrorBoundary appName="Parcours OFA">
      <ToastContainer />
      <Routes>
        <Route element={<RequireConfig />}>
          <Route element={<MatomoProvider/>}>
            <Route element={<BaseLayout hideLogout />}>
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/politique-cookies" element={<PolitiqueCookies />} />
              <Route path="/conditions-utilisation" element={<ConditionUtilisation />} />
              <Route path="/deconnexion" element={<Deconnexion />} />
            </Route>

            <Route element={<RequireSession />}>
              <Route element={<RequireOFARole />}>
                <Route element={<BaseLayout />}>
                  <Route index path="tableau-de-bord" element={<Dashboard />} />

                  <Route path="mon-ofa" element={<MyOfa />} />

                  <Route path="campagne" element={<Campagne />} />

                  <Route path="archives" element={<Archives />} />

                  <Route element={<StepperLayout />}>
                    <Route element={<StepperPage />}>
                      <Route path="/mon-ofa/edition/donnees-complementaires" element={<EditOfaInfoStep1 />} />
                      <Route path="/mon-ofa/edition/activite" element={<EditOfaInfoStep2 />} />
                    </Route>
                  </Route>

                  <Route path="/mon-ofa/edition/etablissement" element={<EditOfaEtablissementsList />} />

                  <Route path="/mon-ofa/edition/etablissement/ajout" element={<EditOfaEtablissement />} />
                  <Route path="/mon-ofa/edition/etablissement/modifier/:etablissementId"
                         element={<EditOfaEtablissement />} />

                  <Route path="/mon-ofa/edition/etablissements/rncp" element={<RncpEtablissementsList />} />
                  <Route path="/mon-ofa/edition/etablissement/:etablissementId/rncp"
                         element={<EditEtablissementRncps />} />

                  <Route path="*" element={<Navigate to="/tableau-de-bord" replace />} />
                </Route>
              </Route>

              <Route
                path="/acces-refuse"
                element={
                  <AccesRefuse
                    titleMessage={'Vous n\'êtes pas autorisé à accéder à cette page.'}
                  />
                }
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </AppErrorBoundary>
  );
}